import { TireSeason } from '@navio/nsdk';
import {
  CAR_WHEEL_ALL_SEASON_VALUE,
  CAR_WHEEL_SUMMER_VALUE,
  CAR_WHEEL_WINTER_VALUE,
  CarWheelSeasonValue
} from 'noddi-types';

// Map TireSeason to numeric values for backward compatibility with APIs
const TireSeasonToNumericValue: Record<TireSeason, CarWheelSeasonValue> = {
  [TireSeason.SUMMER]: CAR_WHEEL_SUMMER_VALUE,
  [TireSeason.WINTER]: CAR_WHEEL_WINTER_VALUE,
  [TireSeason.ALL_SEASON]: CAR_WHEEL_ALL_SEASON_VALUE
};

// Map numeric values to TireSeason
export const NumericValueToTireSeason: Record<CarWheelSeasonValue, TireSeason> = {
  [CAR_WHEEL_SUMMER_VALUE]: TireSeason.SUMMER,
  [CAR_WHEEL_WINTER_VALUE]: TireSeason.WINTER,
  [CAR_WHEEL_ALL_SEASON_VALUE]: TireSeason.ALL_SEASON
};

export const getWheelSeasonValue = (
  season: CarWheelSeasonValue | TireSeason | string | number
): CarWheelSeasonValue => {
  if (typeof season === 'number') {
    return season as CarWheelSeasonValue;
  }
  if (typeof season === 'string') {
    // Check if it's a TireSeason enum value
    if (season in TireSeasonToNumericValue) {
      return TireSeasonToNumericValue[season as TireSeason];
    }
    // Fallback: try uppercase conversion
    const upperSeason = season.toUpperCase() as TireSeason;
    if (upperSeason in TireSeasonToNumericValue) {
      return TireSeasonToNumericValue[upperSeason];
    }
  }
  // Default fallback
  return CAR_WHEEL_SUMMER_VALUE;
};

export const getTireSeasonFromNumericValue = (value: CarWheelSeasonValue): TireSeason => {
  return NumericValueToTireSeason[value] ?? TireSeason.SUMMER;
};

export const limitSummerTires = 1.6;
export const limitWinterTires = 3.0;
export const recommendedSummerTires = 3.0;
export const recommendedWinterTires = 4.5;
